var React = require('react');

function PatternTripleTriangleWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Pattern/TripleTriangle/Line/White"),React.createElement("path",{"d":"M2 15v53h52m0-53v53h52m0-53v53h52M2 68v53h52m0-53v53h52m0-53v53h52","fill":"#FFF","fillRule":"evenodd","key":1})]);
}

PatternTripleTriangleWhite.defaultProps = {"width":"160","height":"160","viewBox":"0 0 160 160"};

module.exports = PatternTripleTriangleWhite;

PatternTripleTriangleWhite.default = PatternTripleTriangleWhite;
